<div class="expansion-section-header">
	<hr class="section-separator" />
	<h4 class="section-heading">{{ label | translate }}</h4>
</div>
